// reading all existing files
export const FILES_FETCH_REQUEST = 'FILES_FETCH_REQUEST';
export const FILES_FETCH_SUCCESS = 'FILES_FETCH_SUCCESS';
export const FILES_FETCH_FAIL = 'FILES_FETCH_FAIL';

// reading one existing file
export const FILE_FETCH_REQUEST = 'FILE_FETCH_REQUEST';
export const FILE_FETCH_SUCCESS = 'FILE_FETCH_SUCCESS';
export const FILE_FETCH_FAIL = 'FILE_FETCH_FAIL';

// uploading a new file
export const FILE_UPLOAD_REQUEST = 'FILE_UPLOAD_REQUEST';
export const FILE_KREDITDATA_SAVE_REQUEST = 'FILE_KREDITDATA_SAVE_REQUEST';

export const FILE_UPLOAD_SUCCESS = 'FILE_UPLOAD_SUCCESS';
export const FILE_UPLOAD_FAIL = 'FILE_UPLOAD_FAIL';

// download a new file
export const FILE_DOWNLOAD_REQUEST = 'FILE_DOWNLOAD_REQUEST';
export const FILE_DOWNLOAD_SUCCESS = 'FILE_DOWNLOAD_SUCCESS';
export const FILE_DOWNLOAD_FAIL = 'FILE_DOWNLOAD_FAIL';

// delete a new file
export const FILE_DELETE_REQUEST = 'FILE_DELETE_REQUEST';
export const FILE_DELETE_SUCCESS = 'FILE_DELETE_SUCCESS';
export const FILE_DELETE_FAIL = 'FILE_DELETE_FAIL';
